import React, { useState, useEffect } from "react";
import { useAppContext } from '../../useAppState'
import { gql } from "@apollo/client";
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Select, Input, Modal, Button } from 'antd';
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './BrokerPermitNumberModal.scss';

const { Option } = Select;

const ADD_PERMIT_INFO = gql`
  mutation AddPermitInfo(
            $id: ID!, 
            $licensedProvinces: String, 
            $CIPR: String, 
    ) {
    addPermitInfo(
            id: $id, 
            licensedProvinces: $licensedProvinces, 
            CIPR: $CIPR, 
        )
  }
`;


const BrokerPermitNumberModal = (props) => {

    const { state, actions } = useAppContext();

    const { t } = useTranslation();

    const [modalShow, setModalShow] = useState(false);
    const [cipr, setCipr] = useState(state.userInfos.CIPR || '');
    const [licensedProvinces, setLicensedProvinces] = useState(state.userInfos.licensedProvinces || []);
    const [error, setError] = useState('');

    const [addPermitInfo] = useMutation(
        ADD_PERMIT_INFO,
        {
            onCompleted(response) {
                console.log(response.addPermitInfo)
                setModalShow(false);
                actions.setUserInfos({
                    ...state.userInfos,
                    licensedProvinces: licensedProvinces,
                    CIPR: licensedProvinces.includes('AB') ? cipr.trim() : null
                });
                props.setEditShowModalBrokerPermitNumberFalse();
                window.location.reload();
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );



    useEffect(() => {
        if (props.enabled && state.userInfos.profile === 'Broker') {

            if (props.isAllCertificatePage && props.editShowModalBrokerPermitNumber) {
                console.log('props.editShowModalBrokerPermitNumber', props.editShowModalBrokerPermitNumber)
                setModalShow(true);
            }

            if (
                !props.isAllCertificatePage &&
                (!state.userInfos.licensedProvinces || state.userInfos.licensedProvinces.length === 0)
            ) {
                setModalShow(true);
            }
        }
    }, [state.userInfos.CIPR, Cookies.get('infoPageVisited'), props.editShowModalBrokerPermitNumber]);

    const handleConfirm = () => {

        if (!licensedProvinces || licensedProvinces.length === 0) {
            setError(state.lang === 'fr' ? 'Les provinces sont manquantes' : 'Provinces are missing');
        } else if (licensedProvinces.includes('AB') && !cipr.trim()) {
            setError(state.lang === 'fr' ? 'Le CIPR est manquant' : 'CIPR is missing');
        } else {
            setError('');
            addPermitInfo({
                variables: {
                    id: state.userInfos.id,
                    licensedProvinces: JSON.stringify(licensedProvinces),
                    CIPR: licensedProvinces.includes('AB') ? cipr.trim() : null
                }
            });
        }
    };

    return (
        <Modal
            title={state.lang === 'fr' ? `Veuillez sélectionner les provinces où vous êtes autorisé` : 'Please select the provinces where you are licensed'}
            centered
            onCancel={() => {
                setModalShow(false);
                props.setEditShowModalBrokerPermitNumberFalse();
                setCipr(state.userInfos.CIPR || '');
                setLicensedProvinces(state.userInfos.licensedProvinces || []);
                setError('');
            }}
            closable={props.isAllCertificatePage ? true : false}
            maskClosable={props.isAllCertificatePage ? true : false}
            open={modalShow}
            okText={t('modal-confirm-btn')}
            cancelText={t('modal-cancel-btn')}
            className={"custom-modal-width"}
            destroyOnClose={true}
            width={'80%'}
            zIndex={9999}
            footer={[
                <div style={{ borderTop: '1px solid #eee', paddingTop: 15 }}>
                    <Button onClick={handleConfirm} type="primary">
                        <FontAwesomeIcon icon={faCheck} /> {state.lang === 'fr' ? 'Confirmer' : 'Confirm'}
                    </Button>
                </div>
            ]}
        >

            <div style={{ minHeight: 100, borderTop: '1px solid #eee', padding: '20px 0 20px 0' }}>

                <label style={{ display: 'block', margin: '0 0 5px 0' }}>
                    Provinces
                </label>
                <Select
                    mode="multiple"
                    id="provinces"
                    name="provinces"
                    value={licensedProvinces}
                    onChange={(value) => setLicensedProvinces(value)}
                    placeholder={state.lang === 'fr' ? 'Selectionnez une ou des Provinces' : 'Select one or more Provinces'}
                    style={{ width: 'calc(100% - 160px)' }}
                >
                    <Option value="AB">Alberta</Option>
                    <Option value="BC">{state.lang === 'fr' ? 'Colombie-Britannique' : 'British Columbia'}</Option>
                    <Option value="MB">Manitoba</Option>
                    <Option value="NB">{state.lang === 'fr' ? 'Nouveau-Brunswick' : 'New Brunswick'}</Option>
                    <Option value="NL">{state.lang === 'fr' ? 'Terre-Neuve-et-Labrador' : 'Newfoundland and Labrador'}</Option>
                    <Option value="NS">{state.lang === 'fr' ? 'Nouvelle-Écosse' : 'Nova Scotia'}</Option>
                    <Option value="ON">Ontario</Option>
                    <Option value="PE">{state.lang === 'fr' ? 'Île-du-Prince-Édouard' : 'Prince Edward Island'}</Option>
                    <Option value="QC">{state.lang === 'fr' ? 'Québec' : 'Quebec'}</Option>
                    <Option value="SK">{state.lang === 'fr' ? 'Saskatchewan' : 'Saskatchewan'}</Option>
                    <Option value="NT">{state.lang === 'fr' ? 'Territoires du Nord-Ouest' : 'Northwest Territories'}</Option>
                    <Option value="NU">{state.lang === 'fr' ? 'Nunavut' : 'Nunavut'}</Option>
                    <Option value="YT">{state.lang === 'fr' ? 'Yukon' : 'Yukon'}</Option>
                </Select>

                {
                    (licensedProvinces && licensedProvinces.includes('AB')) &&
                    <>
                        <label style={{ display: 'block', margin: '20px 0 5px 0' }}>
                            {state.lang === 'fr' ? 'CIPR' : 'CIPR'}
                        </label>
                        <Input
                            type="text"
                            value={cipr}
                            onChange={(e) => setCipr(e.target.value)}
                            placeholder={state.lang === 'fr' ? 'Entrez le CIPR' : 'Enter CIPR'}
                            className="form-control"
                            style={{ maxWidth: '300px', margin: '0' }}
                        />
                    </>
                }

                {error && <Alert variant="danger" style={{ margin: '20px 0  0' }} >{error}</Alert>}
            </div>
        </Modal>
    );
};

export default BrokerPermitNumberModal;